import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ThemMoiTaiSan2 } from "../../components/CommonComponent/ThemMoiTaiSan/index2";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { BtnXuatDanhSach } from "./ChucNang/XuatDanhSach/BtnXuatDanhSach";
import { XuatExcelTaiSan } from "../CommonComponent/XuatExcel/TaiSan";
export const AddTaiSanDeskTopBtn = () => {
  const dataSearch = useSelector((state) => state.dataSearchTaiSan);
  const [show, setShow] = useState(false);
  const [showXuatExcel3, setShowXuatExcel3] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const xuatExcel3 = () => {
    setShowXuatExcel3(true);
  };
  const hideXuatExcel = () => {
    setShowXuatExcel3(false);
  };

  return (
    <div className="iconbutton-new hidden-mobile-main show-table-main">
      <div className="row">
        <div className="col-sm-12 col-md-9"></div>
        <div className="col-sm-12 col-md-3 d-flex just-end">
          <div className="btn-group btn-light-v2">
            <ul>
              <li>
                {" "}
                <BtnXuatDanhSach />
              </li>
              <li>
                <a
                  href={() => false}
                  onClick={xuatExcel3}
                >
                  <PopoversBootrap
                    contentText="Xuất danh sách"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <img src="/app-assets/images/logo-xoa-v2.png" />
                  </PopoversBootrap>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {show && <ThemMoiTaiSan2 show={show} onHide={handleClose} />}
      {showXuatExcel3 && (
        <XuatExcelTaiSan
          dataSearch={dataSearch}
          show={showXuatExcel3}
          onHide={hideXuatExcel}
        ></XuatExcelTaiSan>
      )}
    </div>
  );
};
